import { HardwareVersionDTO } from '@/model';
import { apiGenericDelete, apiGenericGet, apiGenericSave } from '@/service';
import { getApiUrl } from '@/util';
import { DeleteResponse, SaveResponse } from '@/type';

const BASE_URL = '/api/v1/hardwareVersion';

export const listHardwareVersionsAPI = (): Promise<HardwareVersionDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, '/list'));

export const loadHardwareVersionByIdAPI = (id: number): Promise<HardwareVersionDTO> =>
  apiGenericGet(getApiUrl(BASE_URL, `/load/${id}`));

export const saveHardwareVersionAPI = (
  hardwareVersion: HardwareVersionDTO,
): SaveResponse => apiGenericSave(getApiUrl(BASE_URL, '/save'), hardwareVersion);

export const deleteHardwareVersionAPI = (id: number): DeleteResponse =>
  apiGenericDelete(getApiUrl(BASE_URL, '/remove'), 'id', id);
